module.exports = {
	"id": "AW",
	"name": "Aruba",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.005229,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.031374,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.015687,
			"19": null,
			"20": null,
			"21": 0.010458,
			"22": 0.062748,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.010458,
			"27": null,
			"28": 0.010458,
			"29": null,
			"30": null,
			"31": 0.026145,
			"32": 0.020916,
			"33": 0.010458,
			"34": 0.020916,
			"35": 0.020916,
			"36": 0.015687,
			"37": 0.010458,
			"38": 0.031374,
			"39": 0.041832,
			"40": 0.031374,
			"41": null,
			"42": 0.036603,
			"43": 0.036603,
			"44": 0.067977,
			"45": 0.094122,
			"46": 0.020916,
			"47": 0.057519,
			"48": 0.078435,
			"49": 1.390914,
			"50": 0.099351,
			"51": 0.224847,
			"52": 0.188244,
			"53": 19.012644,
			"54": 4.998924,
			"55": 0.062748,
			"56": 0.015687,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.010458,
			"30": null,
			"31": 0.010458,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.010458,
			"37": null,
			"38": 0.010458,
			"39": 0.031374,
			"40": null,
			"41": 0.047061,
			"42": 0.005229,
			"43": 0.036603,
			"44": 0.010458,
			"45": 0.031374,
			"46": 0.031374,
			"47": 0.183015,
			"48": 0.449694,
			"49": 3.780567,
			"50": 0.062748,
			"51": 0.073206,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.026145,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.005229,
			"34": null,
			"35": 0.010458,
			"36": null,
			"37": 0.188244,
			"38": null,
			"39": null,
			"40": 0.125496,
			"41": 0.015687,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.047061
		},
		"safari": {
			"0": null,
			"4": 0.010458,
			"5": 0.010458,
			"6": null,
			"7": 0.015687,
			"8": 0.125496,
			"9": 0.15687,
			"10": 1.950417,
			"3.1": null,
			"3.2": null,
			"5.1": 0.057519,
			"6.1": 0.05229,
			"7.1": 0.047061,
			"9.1": 1.234044
		},
		"ios_saf": {
			"8": 0,
			"10": 11.3889530158,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.306919105329,
			"8.1-8.4": 0.567020042048,
			"9.0-9.2": 0.270504974188,
			"9.3": 4.12693486261
		},
		"android": {
			"3": 0,
			"4": 0.0603217131783,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00754021414729,
			"4.1": 0.217589036822,
			"4.2-4.3": 0.543972592054,
			"4.4": 1.24736685465,
			"4.4.3-4.4.4": 1.25813858915
		},
		"ie": {
			"6": 0.010458,
			"7": 0.031374,
			"8": 0.407862,
			"9": 0.413091,
			"10": 0.956907,
			"11": 7.226478,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0151349558989,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000420415441636
		},
		"edge": {
			"12": 0.151641,
			"13": 0.873243,
			"14": 2.912553
		},
		"ie_mob": {
			"10": 0.0385711830986,
			"11": 0.157039816901
		},
		"bb": {
			"7": 0.10376925,
			"10": null
		},
		"samsung": {
			"0": 9.771008
		},
		"and_uc": {
			"0": 0.391222
		},
		"op_mini": {
			"0": 0.203910628659
		},
		"and_chr": {
			"0": 19.542694
		},
		"and_ff": {
			"0": 0.019084
		}
	},
	"total": 98.84689925
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AW.json
 ** module id = 468
 ** module chunks = 0
 **/